import { AXDialogService } from '@acorex/components/dialog';
import { AXToastService } from '@acorex/components/toast';
import { AXTranslationService } from '@acorex/core/translation';
import { Location } from '@angular/common';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { PlatformService, StorageService } from '@travel/shared/services';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

export class HttpErrorInterceptor implements HttpInterceptor {
  _location = inject(Location);
  toast = inject(AXToastService);
  _platformService = inject(PlatformService);
  _storageService = inject(StorageService);
  _dialogService = inject(AXDialogService);
  protected translateService = inject(AXTranslationService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      headers: request.headers.set('Accept-Language', this._platformService.siteLanguage() || 'fa'),
    });

    const token = this._storageService.get('USER_PROFILE').token;
    if (token) {
      if (!request.url.match('https://map.ir/static')) {
        request = request.clone({
          headers: request.headers.set('Authorization', `Bearer ${token}`),
        });
      }
    }
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        let messages = '';
        let error!: any[];
        switch (err.status) {
          case 500:
            if (err?.error?.messages?.length) {
              messages = `خطا در برقراری ارتباط کد خطا ${err.error.messages[0].code}`;
            } else {
              messages = 'خطا در برقراری ارتباط';
            }
            this.toast.show({
              color: 'danger',
              content: err.url as any,
              title: messages,
              timeOut: 4000,
              timeOutProgress: true,
              // icon: 'fa-regular fa-triangle-exclamation',
            });
            break;
          case 400:
            if (err.error?.messages) {
              error = err.error?.messages;
              error.forEach((el: any, index: number) => {
                messages += error.length > 1 ? index + 1 + '- ' + el.description : '' + el.description;
              });
              // this._dialogService.alert(this.translateService.translateSync('common.attention'), messages, 'danger');
              this.toast.show({
                color: 'danger',
                content: messages,
                title: this.translateService.translateSync('common.attention'),
                timeOut: 4000,
                timeOutProgress: true,
              });
            }
            break;
          case 401:
            if (!err.error?.error_description) {
              // this._dialogService.alert(this.translateService.translateSync('common.attention'), 'خطا در اعتبار سنجی، کلید رمزگذاری شده نامعتبر ', 'danger');
              this.toast.show({
                color: 'danger',
                content: 'خطا در اعتبار سنجی، کلید رمزگذاری شده نامعتبر ',
                title: this.translateService.translateSync('common.attention'),
                timeOut: 4000,
                timeOutProgress: true,
              });
              this._storageService.clear();
            }
            break;
          case 404:
            if (!err.error?.error_description) {
              // this._dialogService.alert(this.translateService.translateSync('common.attention'), 'خطا در اعتبار سنجی، کلید رمزگذاری شده نامعتبر ', 'danger');
              this.toast.show({
                color: 'danger',
                content: 'آدرس مورد نظر وجود ندارد ',
                title: this.translateService.translateSync('common.attention'),
                timeOut: 4000,
                timeOutProgress: true,
              });
            }
            break;
          case 403:
            // this._dialogService.alert(this.translateService.translateSync('common.attention'), 'شما دسترسی به این قسمت ندارید.', 'danger');
            // this._location.back();
            break;
          case 409:
            if (err.error?.messages) {
              error = err.error?.messages;
              error.forEach((el: any, index: number) => {
                messages += error.length > 1 ? index + 1 + '- ' + el.description : '' + el.description;
              });
              this.toast.show({
                color: 'danger',
                content: messages,
                title: this.translateService.translateSync('common.attention'),
                timeOut: 4000,
                timeOutProgress: true,
              });
              // this._dialogService.alert(this.translateService.translateSync('common.attention'), messages, 'danger');
            }
            break;
          default:
            // toast.show({
            //   color: 'danger',
            //   content: err.error?.reason,
            //   timeOut: 4000,
            //   icon: 'fa-regular fa-triangle-exclamation',
            // });
            return throwError(() => err) || null;
          // break;
        }
        return throwError(() => err);
      })
    );
  }
}
